import React, { createContext, useState, useEffect } from 'react';

// Crear el contexto
export const LoginContext = createContext();

// Proveedor del contexto
export const LoginProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedEmpresa = localStorage.getItem('empresaSeleccionada');

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedEmpresa) {
      setSelectedEmpresa(JSON.parse(storedEmpresa));
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const selectEmpresa = (empresa) => {
    setSelectedEmpresa(empresa);
    localStorage.setItem('empresaSeleccionada', JSON.stringify(empresa));
  };

  const logout = () => {
    setUser(null);
    setSelectedEmpresa(null);
    localStorage.removeItem('user');
    localStorage.removeItem('empresaSeleccionada');
  };

  const clearEmpresaSelection = () => {
    setSelectedEmpresa(null);
    localStorage.removeItem('empresaSeleccionada');
  };

  const isAuthenticated = !!user;

  return (
    <LoginContext.Provider
      value={{
        user,
        selectedEmpresa,
        login,
        selectEmpresa,
        clearEmpresaSelection,
        logout,
        isAuthenticated,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};